export default __webpack_public_path__ + "static/media/connex_ai.dc14140e.png";